export class Period {
    id: number;
    name: string;
    validationValue: number;
}
